/**
 * Target rendered stroke width (in CSS px) for every shape in the library.
 * Polygon / rectangle / ellipse / diamond elements render at exactly this
 * value when their `strokeWidth` field is set to it.
 */
export const SHAPE_STROKE_WIDTH = 2;

/**
 * Freedraw elements render visually thicker than line elements at the same
 * nominal `strokeWidth`. Excalidraw passes `size = strokeWidth * 4.25` to
 * perfect-freehand (packages/element/src/shape.ts:1191-1199), but the
 * filled outline path tends to look heavier than a stroked line of the
 * same nominal width. The divisor below is tuned empirically to match the
 * visual weight of polygon shapes; bump it higher to make Terminal
 * thinner, lower to make it thicker.
 */
export const FREEDRAW_STROKE_WIDTH = SHAPE_STROKE_WIDTH / 6;
